<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--300" no-body>
                    <div class="px-4">
                        <div class="row justify-content-center">
                            <div class="col-lg-3 order-lg-2">
                                <div class="card-profile-image">
                                    <div>
                                        <img v-lazy="'img/theme/profile-picture-b&w.jpg'" class="rounded-circle">
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 order-lg-3 text-lg-right align-self-lg-center">
                                <div class="card-profile-actions py-4 mt-lg-0">
                                    <a href="https://www.linkedin.com/in/moreaujulien/" target="_blank">
                                        <base-button type="default" size="sm" class="mr-4">Connect</base-button>
                                    </a>
                                    <router-link to="/contact">
                                        <base-button type="info" size="sm" class="float-right">Message</base-button>
                                    </router-link>
                                </div>
                            </div>
                            <div class="col-lg-4 order-lg-1">
                                <div class="card-profile-stats d-flex justify-content-center">
                                    <div>
                                        <span class="heading">5,847 <i class="fa fa-stack-overflow"></i></span>
                                        <span class="description">Reputation</span>
                                    </div>
                                    <div>
                                        <span class="heading">Fr / Eng / Spa</span>
                                        <span class="description">Speaker</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center mt-5">
                            <h3>Julien Moreau
                            </h3>
                            <div class="h6 font-weight-300"><i class="ni location_pin mr-2"></i>Barcelona, Spain</div>
                            <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i>Cloud Architect & Developer</div>
                        </div>
                        <div class="mt-5 py-5 border-top text-center">
                            <div class="row justify-content-center">
                                <div class="col-lg-9">
                                    <p>An artist of considerable range, Ryan — the name taken by Melbourne-raised, Brooklyn-based Nick Murphy — writes, performs and records all of his own music, giving it a warm, intimate feel with a solid groove structure. An artist of considerable range.</p>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="py-5">
                            <img v-lazy="'img/developer_certificate_badge.png'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 200px;">
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>
<script>
export default {

};
</script>
<style>
</style>
